import { alertError } from 'src/store/alert/actions';
import { apiUrl } from '../../index';
import axios, { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { EventgroupActiontypes } from './types';
import { CardEventGroup } from '../events/types';

export const getAllEventGroups = () => {
  const fetchRequest = () => action(EventgroupActiontypes.FETCH_REQUEST);
  const fetchSuccess = (data: CardEventGroup[]) =>
    action(EventgroupActiontypes.FETCH_SUCCESS, { data });
  const fetchError = (error: Error) => action(EventgroupActiontypes.FETCH_ERROR, error);

  interface Response {
    cardeventgroups: CardEventGroup[];
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/events/eventgroups')
      .then((res: AxiosResponse<Response>) => {
        dispatch(fetchSuccess(res.data.cardeventgroups));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/eventgroups/actions.ts